import CreateAdminForm from '../components/admin/CreateAdminForm';
import { useTranslation } from 'react-i18next';

export default function CreateAdminPage() {
  const { t } = useTranslation(['admin']);
  return (
    <>
      <div className="w-full pt-4 pb-5 flex flex-col md:w-2/3 md:px-1 md:pr-8 md:pb-10">
        <h1 className="text-5xl font-bold hyphens-auto">
          {t('navigation.create', { ns: 'admin', defaultValue: 'Ajouter un administrateur' })}
        </h1>
      </div>
      <CreateAdminForm />
    </>
  );
}
